export default "__VITE_ASSET__D3PkW4i1__"